import ENV from "../../env";
import ErrorContent from "../ErrorContent/ErrorContent";
import { useAuthTranslation } from "../../services/culture/auth.translations";
import { useCommonTranslation } from "../../services/culture/common.translations";

export const ErrorComponent = () => {
  const { t: tAuth } = useAuthTranslation();
  const { t: tCommon } = useCommonTranslation();
  const errorTitle = new URLSearchParams(window.location.search).get("title") || tAuth("errors.unknownError");
  const errorMessage = new URLSearchParams(window.location.search).get("message") || "";

  return (
    <ErrorContent
      title={errorTitle}
      message={errorMessage}
      actions={[
        {
          label: tCommon("common.returnToLogin"),
          color: "#212134",
          onClick: () => {
            // get client_id, redirect_uri, response_type, and scope from localStorage
            const clientId = localStorage.getItem("client_id");
            const redirectUri = localStorage.getItem("redirect_uri");
            const responseType = localStorage.getItem("response_type") || "code";
            const scope = localStorage.getItem("scope") || "openid";
            const state = localStorage.getItem("state") || "";
            if (clientId && redirectUri) {
              window.location.replace(
                `${ENV.BASE_PATH}/login?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&state=${state}`,
              );
            } else {
              window.location.replace(`${ENV.BASE_PATH}/login`);
            }
          },
        },
      ]}
    />
  );
};
